export default {
	styleOverrides: {
		root: ({ theme }) => ({
			'& .MuiSlider-track': {
				backgroundColor: theme.palette.black,
				borderColor: theme.palette.black,
				height: '1px',
			},
			'& .MuiSlider-thumb': {
				backgroundColor: theme.palette.secondary.main,
				width: '16px',
				height: '16px',
			},
		}),
	},
}
